import { useState } from 'react';
import { lastMonths } from '@blimo/shared';
import { ToggleGroup } from '@blimo/ui';
import { FilterBar } from '../../components/filter-bar.jsx';
import { CostsPanel, OpenItemsPanel, OpTypeToggle, PeriodFilter, RentDevelopmentPanel, VatToggle } from './panels.jsx';

const VIEWS = [
  { value: 'op', label: 'Offene Posten' },
  { value: 'kosten', label: 'Kosten' },
  { value: 'miete', label: 'Mietentwicklung' },
];

/** Liegenschaft › Finanzen: OP, Kosten, Mietentwicklung of one property (same services as the portal). */
export function PropertyFinanceTab({ propertyId }) {
  const [view, setView] = useState('op');
  const [opType, setOpType] = useState();
  const [period, setPeriod] = useState(() => lastMonths(12));
  const [vat, setVat] = useState();
  return (
    <div className="flex flex-col gap-3">
      <ToggleGroup label="Finanzansicht" value={view} onValueChange={setView} options={VIEWS} />
      {view === 'op' && (
        <>
          <FilterBar>
            <OpTypeToggle value={opType} onChange={setOpType} />
          </FilterBar>
          <OpenItemsPanel propertyId={propertyId} opType={opType} />
        </>
      )}
      {view !== 'op' && (
        <FilterBar>
          <PeriodFilter period={period} onChange={setPeriod} />
          {view === 'kosten' && <VatToggle value={vat} onChange={setVat} />}
        </FilterBar>
      )}
      {view === 'kosten' && <CostsPanel propertyId={propertyId} period={period} vat={vat} />}
      {view === 'miete' && <RentDevelopmentPanel propertyId={propertyId} period={period} />}
    </div>
  );
}
